"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var Box_1 = __importDefault(require("@mui/material/Box"));
var firestore_1 = require("firebase/firestore");
var markdown_to_jsx_1 = __importDefault(require("markdown-to-jsx"));
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var StepIcon_1 = __importDefault(require("atomicComponents/molecules/Icon/StepIcon"));
var InfoTooltip_1 = __importDefault(require("atomicComponents/organisms/Tooltip/InfoTooltip"));
var StepTitle_1 = __importDefault(require("containers/Onboarding/styles/StepTitle"));
var StepWrapper_1 = __importDefault(require("containers/Onboarding/styles/StepWrapper"));
var utils_1 = require("containers/Onboarding/utils");
var hooks_1 = require("utils/hooks");
var single_1 = require("utils/selectors/single");
var SubStep = function (_a) {
    var _b, _c, _d, _e;
    var subStep = _a.subStep, subStepsMap = _a.subStepsMap;
    var _f = __read(react_1.default.useState(false), 2), isModalOpen = _f[0], setIsModalOpen = _f[1];
    var _g = __read(react_1.default.useState(true), 2), isModalFullyClosed = _g[0], setIsModalFullyClosed = _g[1];
    var rechargerCompany = (0, react_redux_1.useSelector)(single_1.selectMyRechargerCompany);
    var _h = __read((0, hooks_1.useSubmitter)('recharger_companies', rechargerCompany === null || rechargerCompany === void 0 ? void 0 : rechargerCompany.id, {
        rechargeSetupSubSteps: (0, firestore_1.arrayUnion)(subStep),
    }), 1), rechargerCompanySubmitter = _h[0];
    var subStepDef = subStepsMap[subStep];
    react_1.default.useEffect(function () {
        if (!isModalOpen) {
            var t_1 = setTimeout(function () { return setIsModalFullyClosed(!isModalOpen); }, 500);
            return function () { return clearTimeout(t_1); };
        }
        setIsModalFullyClosed(!isModalOpen);
        return undefined;
    }, [isModalOpen]);
    var StepComponent = subStepDef.StepComponent, to = subStepDef.to, toWhenDone = subStepDef.toWhenDone, label = subStepDef.label, disabledCondition = subStepDef.disabledCondition, infoTooltip = subStepDef.infoTooltip, ModalComponent = subStepDef.ModalComponent, getStatus = subStepDef.getStatus, stepConf = subStepDef.stepConf;
    var isSubStepDone = (_b = rechargerCompany === null || rechargerCompany === void 0 ? void 0 : rechargerCompany.rechargeSetupSubSteps) === null || _b === void 0 ? void 0 : _b.includes(subStep);
    var status = (rechargerCompany && (getStatus === null || getStatus === void 0 ? void 0 : getStatus(rechargerCompany)));
    var iconStatus = (_c = status === null || status === void 0 ? void 0 : status.status) !== null && _c !== void 0 ? _c : (isSubStepDone ? 'success' : 'default');
    var isSubStepDisabled = !!disabledCondition;
    var setStep = function (extras) { return rechargerCompanySubmitter(extras); };
    if (StepComponent) {
        return ((0, jsx_runtime_1.jsx)(material_1.ListItem, __assign({ disablePadding: true, disableGutters: true }, { children: (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, spacing: 1, width: 1, ml: 1, mt: 0, height: 48 }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ item: true, xs: 12, md: 6, display: "inline-flex", alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(Box_1.default, __assign({ mr: 4 }, { children: (0, jsx_runtime_1.jsx)(StepIcon_1.default, { status: iconStatus }) })), label && ((0, jsx_runtime_1.jsx)(StepTitle_1.default, __assign({ isDisabled: isSubStepDisabled, mr: 1 }, stepConf, { children: (0, jsx_runtime_1.jsx)(markdown_to_jsx_1.default, { children: "".concat(label, " ").concat((_d = status === null || status === void 0 ? void 0 : status.text) !== null && _d !== void 0 ? _d : '') }) }))), infoTooltip && (0, jsx_runtime_1.jsx)(InfoTooltip_1.default, { title: infoTooltip })] })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12, md: 6, display: "inline-flex", justifyContent: "flex-end", alignItems: "center" }, { children: (0, jsx_runtime_1.jsx)(StepComponent, { setStep: setStep }) }))] })) })));
    }
    return ((0, jsx_runtime_1.jsxs)(material_1.ListItem, __assign({ disablePadding: true, disableGutters: true }, { children: [(0, jsx_runtime_1.jsxs)(StepWrapper_1.default, __assign({ to: (0, utils_1.getTo)(isSubStepDone, isSubStepDisabled, to, toWhenDone) || '#', onClick: function () {
                    if (isSubStepDisabled || (!subStepDef.addStepOnClick && !subStepDef.ModalComponent))
                        return null;
                    if (subStepDef.ModalComponent)
                        return setIsModalOpen(true);
                    return null;
                    // return stepAdder(subStepDef.label);
                }, disabled: isSubStepDisabled, compressed: true }, { children: [(0, jsx_runtime_1.jsx)(Box_1.default, __assign({ mr: 4 }, { children: (0, jsx_runtime_1.jsx)(StepIcon_1.default, { status: iconStatus }) })), label && ((0, jsx_runtime_1.jsx)(StepTitle_1.default, __assign({ isDisabled: isSubStepDisabled, mr: 3 }, stepConf, { children: (0, jsx_runtime_1.jsx)(markdown_to_jsx_1.default, { children: "".concat(label, " ").concat((_e = status === null || status === void 0 ? void 0 : status.text) !== null && _e !== void 0 ? _e : '') }) }))), infoTooltip && (0, jsx_runtime_1.jsx)(InfoTooltip_1.default, { title: infoTooltip })] })), ModalComponent && !isModalFullyClosed && ((0, jsx_runtime_1.jsx)(ModalComponent, { open: isModalOpen, onClose: function () { return setIsModalOpen(false); }, setStep: setStep }))] })));
};
exports.default = SubStep;
